export default "__VITE_ASSET__yG0Opi_V9aYPvWSzqGTDmw__";